import { NavLink, Outlet } from 'react-router-dom'

import { useAuth } from '../../auth/AuthContext.js'
import { SignOutButton } from '../../components'
import styles from './AdminLayout.module.css'

const ADMIN_NAV_ITEMS = [
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/audit', label: 'Audit' },
  { to: '/admin/moderation', label: 'Moderation' },
  { to: '/admin/stats', label: 'Stats' },
]

const TEACHER_NAV_ITEMS = [
  { to: '/teacher/decks', label: 'Decks and cards' },
  { to: '/teacher/classes', label: 'Classrooms' },
]

export default function AdminLayout(): JSX.Element {
  const { email } = useAuth()

  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar}>
        <div className={styles.brandBlock}>
          <p className={styles.eyebrow}>Study Decks</p>
          <h1 className={styles.title}>Admin Console</h1>
          <p className={styles.subtitle}>
            Manage access, review privileged changes, and keep roles predictable.
          </p>
        </div>
        <nav aria-label="Admin navigation" className={styles.nav}>
          <NavSection label="Admin" items={ADMIN_NAV_ITEMS} />
          <NavSection label="Teacher tools" items={TEACHER_NAV_ITEMS} />
        </nav>
        <div className={styles.sessionCard}>
          <p className={styles.sessionLabel}>Signed in as</p>
          <p className={styles.sessionValue}>{email ?? 'Admin account'}</p>
          <SignOutButton />
        </div>
      </aside>
      <main id="main-content" className={styles.main}>
        <Outlet />
      </main>
    </div>
  )
}

interface NavSectionProps {
  label: string
  items: Array<{ to: string; label: string }>
}

function NavSection({ label, items }: NavSectionProps): JSX.Element {
  return (
    <div className={styles.navSection}>
      <p className={styles.navSectionLabel}>{label}</p>
      <ul className={styles.navList}>
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                [styles.navLink, isActive ? styles.navLinkActive : ''].filter(Boolean).join(' ')
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  )
}
